/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * TableRow CSS
 */
export const styles = css`
  :host {
    display: table-row;
    width: 100%;
    height: 100%;
    height: max-content;
    border-bottom: 1px solid var(--nile-table-row-border-color , var(--ng-colors-border-secondary));
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  slot::slotted(nile-table-header-item) {
    background-color: var(--nile-table-header-background-color , var(--ng-colors-bg-secondary));
  }

  
`;

export default [styles];
